import { formatCurrencyFn } from "../../Core/Functions/formatCurrencyFn";
import type { PaymentSummaryModel } from "../../Core/Models/PaymentModels";

export const PaymentStatusCardPiece = ({
  description,
  eyebrow,
  title,
}: {
  description: string;
  eyebrow: string;
  title: string;
}) => (
  <div className="panel-surface p-6 sm:p-8">
    {eyebrow && <span className="eyebrow-label">{eyebrow}</span>}
    <h1 className="mt-4 font-display text-display-md uppercase text-white">
      {title}
    </h1>
    <p className="mt-4 max-w-2xl text-base leading-8 text-cmj-mist">{description}</p>
  </div>
);

export const PaymentSummaryPiece = ({
  summary,
}: {
  summary: PaymentSummaryModel;
}) => (
  <div className="panel-surface p-6 sm:p-8">
    <p className="text-xs font-black uppercase text-cmj-gold">Payment summary</p>
    <div className="mt-5 grid gap-4">
      <div className="rounded-md border border-white/10 bg-white/5 p-4">
        <p className="text-xs font-black uppercase text-cmj-mist">Package</p>
        <p className="mt-2 text-lg text-white">
          {summary.booking?.packageName || "Booking not found"}
        </p>
      </div>
      <div className="rounded-md border border-white/10 bg-white/5 p-4">
        <p className="text-xs font-black uppercase text-cmj-mist">Session</p>
        <p className="mt-2 text-lg text-white">
          {summary.booking
            ? `${summary.booking.preferredDate} at ${summary.booking.preferredTime}`
            : "Unavailable"}
        </p>
      </div>
      <div className="rounded-md border border-white/10 bg-white/5 p-4">
        <p className="text-xs font-black uppercase text-cmj-mist">Amount</p>
        <p className="mt-2 text-lg text-white">
          {summary.payment ? formatCurrencyFn(summary.payment.amount) : "Unavailable"}
        </p>
      </div>
      <div className="rounded-md border border-white/10 bg-white/5 p-4">
        <p className="text-xs font-black uppercase text-cmj-mist">Status</p>
        <p className="mt-2 text-lg font-black uppercase text-cmj-gold">
          {summary.payment?.status || summary.booking?.status || "Unknown"}
        </p>
      </div>
    </div>
  </div>
);
